<template>
  <element>
    <AppBar :title="$t('New Registration')" />
    <v-container>
      <v-carousel :show-arrows="false">
        <v-carousel-item
          v-for="(item, i) in items"
          :key="i"
          :src="item.src"
          reverse-transition="fade-transition"
          transition="fade-transition"
        >
        </v-carousel-item>
      </v-carousel>
      <LabelTextField class="mb-5" :label="$t('registrationPage.label-1')" />
      <LabelTextField class="mb-5" :label="$t('registrationPage.label-2')" />
      <router-link to="/collectionlist">
        <v-btn
          color="#033e8c"
          height="45px"
          block
          dark
        >
        {{ $t('registrationPage.button') }}
        </v-btn>
      </router-link>
    </v-container>
  </element>
</template>

<script>
import AppBar from "@/components/common/AppBar.vue";
import LabelTextField from "@/components/common/LabelTextField.vue";

export default {
  name: "NewRegistrationPage",
  components: {
    AppBar,
    LabelTextField,
  },
  props: {},
  data () {
    return {
      items: [
          {
            src: '/img/camera-placeholder.gif',
          },
          {
            src: '/img/image-01-B_v1592817855.jpg',
          },
          {
            src: '/img/image-02-B_v1592817855.jpg',
          },
          {
            src: '/img/image-03-B_v1592817855.jpg',
          },
          {
            src: '/img/image-03-B_v1592817855.jpg',
          },
        ],
    }
  }
}
</script>

<style scoped>

</style>